import { Component } from 'react';

import { configValue } from '#/config/appConfigUtils';
import { I18n } from '#/i18n/components/I18n';
import type { I18nLocale } from '#/i18n/types/I18nLocale';
import { recaptcha } from '#/utils/recaptcha';

import { StyledRecaptchaInput } from './RecaptchaInput.styled';

export class RecaptchaInput extends Component<{
  // TODO: Fix this the next time the file is edited.
  // oxlint-disable-next-line typescript/no-explicit-any
  onChange: (...args: any[]) => any;
  siteKey?: string | null;
}> {
  setupRecaptcha = (el: Element | null | undefined, locale: I18nLocale) => {
    if (!el) return;
    // oxlint-disable-next-line typescript/no-explicit-any
    recaptcha({ locale }).then((r: any) => {
      const { siteKey, onChange } = this.props;
      r.render(el, {
        sitekey: siteKey ?? configValue('google', 'recaptcha', 'siteKey'),
        // oxlint-disable-next-line typescript/no-explicit-any
        callback: (response: any) => {
          onChange(response);
        },
        'expired-callback': () => {
          // Remove old value because it's no longer valid
          onChange();
        },
      });
    });
  };

  render() {
    return (
      <I18n
        render={({ locale }) => (
          <StyledRecaptchaInput ref={(el) => this.setupRecaptcha(el, locale)} />
        )}
      />
    );
  }
}
